import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'
import type { AllSlice } from './types'
import type { StateCreator } from 'zustand'

export type ZMiddlewares = [
  ['zustand/immer', never],
  ['zustand/devtools', unknown],
  // ['zustand/subscribeWithSelector', never],
  // ['zustand/persist', unknown],
]

function zustandMiddlewares(f: StateCreator<AllSlice>) {
  return immer(
    devtools(f, {
      name: 'bear store',
      enabled: process.env.NODE_ENV === 'development',
    }),
  )
}

export default zustandMiddlewares
